module.exports = __webpack_public_path__ + "static/media/dhn-newlogo-transparent.ee4d6718.png";